/**
 * Mock notifications — drives the provider Notifications page.
 *
 * Returns the shape expected by useNotifications() inside NotificationsPage.tsx:
 *   { id, kind, title, body, read, created_at, link? }
 */

export interface MockNotification {
  id: string
  kind: 'lead' | 'booking' | 'review' | 'quote' | 'general'
  title: string
  body: string
  read: boolean
  created_at: string
  link?: string
}

const NOW = Date.parse('2026-05-01T08:00:00.000Z')
const T = (mins: number) => new Date(NOW - mins * 60_000).toISOString()

export const MOCK_NOTIFICATIONS: MockNotification[] = [
  { id: 'n1',  kind: 'lead',    title: 'Ny förfrågan i Stockholm',
    body: 'Filip Sköld söker hjälp med "Bygga väggfast TV-bänk" — passar din profil.',
    read: false, created_at: T(35), link: '/leverantor/jobs/4' },
  { id: 'n2',  kind: 'booking', title: 'Bokning bekräftad',
    body: 'Tilde Falk har bekräftat bokning torsdag 14:00 (Säsongsavtal gräsklippning).',
    read: false, created_at: T(120), link: '/leverantor/bokningar' },
  { id: 'n3',  kind: 'review',  title: 'Nytt omdöme — 5 stjärnor',
    body: 'Magnus Holm: "Sigge gjorde ett otroligt jobb. Snabbt, rent och proffsigt utfört."',
    read: false, created_at: T(60 * 8), link: '/leverantor/recensioner' },
  { id: 'n4',  kind: 'quote',   title: 'Offert visad',
    body: 'Din offert till "Montering av IKEA garderober" har lästs av kunden.',
    read: true,  created_at: T(60 * 24), link: '/leverantor/offerter' },
  { id: 'n5',  kind: 'lead',    title: 'Ny förfrågan: Pianoflytt',
    body: 'Karin Sundström söker hjälp att flytta ett piano i Stockholm.',
    read: true,  created_at: T(60 * 30), link: '/leverantor/jobs/15' },
  { id: 'n6',  kind: 'booking', title: 'Påminnelse: jobb imorgon',
    body: 'Du har bokning hos Tilde Falk imorgon kl 14:00.',
    read: true,  created_at: T(60 * 45), link: '/leverantor/bokningar' },
  { id: 'n7',  kind: 'review',  title: 'Kund svarade på ditt svar',
    body: 'Astrid Norén tackade för ditt svar på sitt omdöme.',
    read: true,  created_at: T(60 * 60), link: '/leverantor/recensioner' },
  { id: 'n8',  kind: 'lead',    title: 'Ny förfrågan i Stockholm',
    body: 'Hanna Wikström söker hjälp med kakling av badrum.',
    read: true,  created_at: T(60 * 80), link: '/leverantor/jobs/10' },
  { id: 'n9',  kind: 'quote',   title: 'Offert accepterad!',
    body: 'Din offert på "Montering av IKEA garderober" har accepterats.',
    read: true,  created_at: T(60 * 100), link: '/leverantor/bokningar' },
  { id: 'n10', kind: 'general', title: 'Hjälptorget Veckosammanfattning',
    body: 'Du fick 3 nya förfrågningar och 2 bokningar förra veckan. Bra jobbat!',
    read: true,  created_at: T(60 * 24 * 7), link: '/leverantor/statistik' },
]
